<template>
  <div class="pa-10">
    <v-card class="mt-2">
      <v-row class="">
        <v-col cols="12">
          <!-- <InstructorOjtOrgDataTable /> -->
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
// import InstructorOjtOrgDataTable from "@/components/Utils/InstructorOjtOrgDataTable.vue";
export default {
  components: {
    // OJTOrgsDataTable,
    // InstructorOjtOrgDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {
    // shouldShow() {
    //   let allowed = [2, 3];
    //   return allowed.includes($store.state.user.usertype.id);
    // },
  },
};
</script>

<style></style>
